import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import css from '@styled-system/css';
import styled from 'styled-components';
import { Flex } from '../Flex/index.js';
import { Icon } from '../Icon/index.js';
import { Box } from '../Box/index.js';

const StyledTriggerRight = styled(AccordionPrimitive.Trigger).withConfig({
  displayName: "AccordionTrigger__StyledTriggerRight",
  componentId: "sc-1tuch8f-0"
})(css({
  justifyContent: 'space-between',
  'svg[data-test-id="accordion-trigger-icon"]': {
    transition: 'transform 300ms'
  },
  '&[data-state="open"] svg[data-test-id="accordion-trigger-icon"]': {
    transform: 'rotate(-180deg)'
  },
  '&[data-focus-visible-added]:not(:disabled)': {
    outline: 'none'
  }
}));
const StyledTriggerLeft = styled(AccordionPrimitive.Trigger).withConfig({
  displayName: "AccordionTrigger__StyledTriggerLeft",
  componentId: "sc-1tuch8f-1"
})(css({
  flexDirection: 'row-reverse',
  justifyContent: 'flex-end',
  'svg[data-test-id="accordion-trigger-icon"]': {
    transition: 'transform 300ms',
    mr: 'space30'
  },
  '&[data-state="open"] svg[data-test-id="accordion-trigger-icon"]': {
    transform: 'rotate(90deg)'
  },
  '&[data-focus-visible-added]:not(:disabled)': {
    outline: 'none'
  }
}));
/**
 * AccordionTrigger toggles the collapsed state of its associated item. It should be nested inside of an AccordionHeader
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 * <br />
 *
 */
const AccordionTrigger = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    dataTestId = 'accordion-trigger',
    name,
    iconPosition,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef,
    _focusVisible: {
      boxShadow: 'focusInset'
    },
    as: iconPosition === 'right' ? StyledTriggerRight : StyledTriggerLeft,
    backgroundColor: "white",
    border: "none",
    borderRadius: "radiusDefault",
    cursor: "pointer",
    "data-test-id": dataTestId,
    fontSize: "fontSize20",
    px: "space30",
    py: "space50",
    width: "100%"
  }, props), /*#__PURE__*/React__default.createElement(Flex, {
    width: "100%"
  }, children), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Icon, {
    dataTestId: "accordion-trigger-icon",
    name: name,
    size: "large"
  })));
});
AccordionTrigger.displayName = 'AccordionTrigger';

export { AccordionTrigger, StyledTriggerLeft, StyledTriggerRight };
